var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ENDLESS_PAGE_MINIMUM_LENGTH_MM, MATFILE_ENDLESS_TYPE } from "pxc-editor-core/constants";
import { parse as parseMaterial } from "pxc-editor-core/helpers/material";
import { colors } from '@/globalStyles';
import { COLOR_MODE, NO_PRINTER_ID } from '@/constants';
import { convert } from '@/helpers/matfile/matfile_print_params';
var originMatFile = null;
var matfileTemplate = null;
var mapBackgroundStyle = function (value) {
    if (value.hasOwnProperty('color_mode')) {
        var _a = value, color_mode = _a.color_mode, color = _a.color;
        switch (color_mode) {
            case COLOR_MODE.DEFINED_COLOR: {
                return { enabled: true, fill_color: color, color_mode: color_mode };
            }
            case COLOR_MODE.VARIANT_COLOR: {
                return { enabled: false, fill_color: color, color_mode: color_mode };
            }
            case COLOR_MODE.WITHOUT_COLOR:
            case COLOR_MODE.VARIANT_ELEMENT_COLOR_OR_DEFINED_COLOR:
            default: {
                return { enabled: false, fill_color: colors.transparent, color_mode: color_mode };
            }
        }
    }
    if (value.hasOwnProperty('fill_color')) {
        var _b = value, enabled = _b.enabled, fill_color = _b.fill_color;
        return { enabled: enabled, fill_color: fill_color, color_mode: '' };
    }
    return value;
};
export var getOriginMatFile = function () {
    return originMatFile;
};
export var getBuildedMatfileTemplate = function () {
    return matfileTemplate;
};
export var parseV2Id = function (id) {
    var ids = id
        .replace('g', 'g:')
        .replace('m', ',m:')
        .replace('s', ',s:')
        .replace('p', ',p:').split(',');
    var g = 0;
    var m = 0;
    var s = 0;
    var p = null;
    ids.forEach(function (v) {
        var val = v.split(':');
        if ((val === null || val === void 0 ? void 0 : val.length) > 1) {
            switch (val[0]) {
                case 'g':
                    g = (Number(val[1]));
                    break;
                case 'm':
                    m = (Number(val[1]));
                    break;
                case 's':
                    s = (Number(val[1]));
                    break;
                case 'p':
                    p = val[1].split('_');
                    break;
                default:
                    break;
            }
        }
    });
    return {
        g: g,
        m: m,
        s: s,
        p: p,
    };
};
export var getPrimitivesArrayFromObject = function (o, tpa, revertY, x, y, width, height) {
    var _a;
    var result = [];
    if ((o === null || o === void 0 ? void 0 : o.rect) && Array.isArray(o.rect)) {
        var _rect = o.rect.map(function (s) {
            return {
                id: s.id,
                box: {
                    l: s.location[x],
                    t: revertY ? tpa.b - (s.location[y] + s.size[height]) : s.location[y],
                    r: s.size[width],
                    b: s.size[height]
                },
                contour: {
                    primitive_type: "RECT",
                    rect: {
                        x: s.location[x],
                        y: revertY ? tpa.b - (s.location[y] + s.size[height]) : s.location[y],
                        w: s.size[width],
                        h: s.size[height],
                        roundedCornerRadius: s.roundedCornerRadius,
                        angle: s.angle || 0,
                        outline_style: {
                            enabled: s.thickness > 0,
                            color: "#000000",
                            line_width: s.thickness,
                            line_type: "SOLID"
                        },
                        background_style: mapBackgroundStyle(s.background_style)
                    }
                },
                z: 0
            };
        });
        result = __spreadArray(__spreadArray([], __read(result), false), __read(_rect), false);
    }
    if ((o === null || o === void 0 ? void 0 : o.circle) && Array.isArray(o.circle)) {
        var _circle = (_a = o.circle) === null || _a === void 0 ? void 0 : _a.map(function (c) {
            var result = {
                id: c.id,
                primitive_type: "CIRCLE",
                circle: {
                    x: c[x],
                    y: revertY ? tpa.b - c[y] : c[y],
                    radius: c.radius,
                    thickness: c.thickness,
                    color: c.color,
                    layer: c.layer,
                }
            };
            return result;
        });
        result = __spreadArray(__spreadArray([], __read(result), false), __read(_circle), false);
    }
    if ((o === null || o === void 0 ? void 0 : o.polygon) && Array.isArray(o.polygon)) {
        var _polygon = o.polygon.map(function (s) {
            var _a;
            return {
                id: s.id,
                contour: {
                    primitive_type: "POLYGON",
                    polygon: {
                        points: (_a = s.points) === null || _a === void 0 ? void 0 : _a.map(function (p) {
                            return [p[x], (revertY ? tpa.b - p[y] : p[y])];
                        }),
                        background_style: mapBackgroundStyle(s.background_style),
                    },
                }
            };
        });
        result = __spreadArray(__spreadArray([], __read(result), false), __read(_polygon), false);
    }
    if ((o === null || o === void 0 ? void 0 : o.line) && Array.isArray(o.line)) {
        var _line = o.line.map(function (s) {
            return {
                id: s.id,
                contour: {
                    primitive_type: "LINE",
                    line: {
                        start_point: {
                            x: s.start_point[x],
                            y: revertY ? tpa.b - s.start_point[y] : s.start_point[y],
                        },
                        end_point: {
                            x: s.end_point[x],
                            y: revertY ? tpa.b - s.end_point[y] : s.end_point[y],
                        },
                    },
                }
            };
        });
        result = __spreadArray(__spreadArray([], __read(result), false), __read(_line), false);
    }
    if ((o === null || o === void 0 ? void 0 : o.text) && Array.isArray(o.text)) {
        var _text = o.text.map(function (t) {
            var _a, _b, _c, _d;
            if ((_a = t.text_style) === null || _a === void 0 ? void 0 : _a.vertical_alignment) {
                t.text_style.vertical_alignment = ((_b = t.text_style) === null || _b === void 0 ? void 0 : _b.vertical_alignment).toUpperCase().replace('CENTER', 'MIDDLE');
            }
            if ((_c = t.text_style) === null || _c === void 0 ? void 0 : _c.horizontal_alignment) {
                t.text_style.horizontal_alignment = ((_d = t.text_style) === null || _d === void 0 ? void 0 : _d.horizontal_alignment).toUpperCase();
            }
            var result = {
                id: t.id,
                primitive_type: "TEXT",
                text: {
                    text: t.text,
                    text_style: t.text_style,
                    position: {
                        x: t.location[x],
                        y: revertY ? tpa.b - (t.location[y] + t.size[height]) : t.location[y]
                    }
                }
            };
            return result;
        });
        result = __spreadArray(__spreadArray([], __read(result), false), __read(_text), false);
    }
    return result;
};
var PRINTER_CODE_CARD_PRIME = 16;
var parseVersion1MatfileToBasicVersion = function (_matFile) {
    return _matFile;
};
var parseVersion2MatfileToBasicVersion = function (_matFile, _selPrinter) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var material = (_matFile === null || _matFile === void 0 ? void 0 : _matFile.material) || _matFile;
    var general = material.general, material_layout = material.material_layout, _u = material.none_printable_decorations, none_printable_decorations = _u === void 0 ? {
        rect: [],
        polygon: [],
        line: [],
        circle: [],
        arches: [],
        text: [],
    } : _u, _v = material.printable_decorations, printable_decorations = _v === void 0 ? {
        rect: [],
        polygon: [],
        line: [],
        circle: [],
        arches: [],
        text: [],
    } : _v, marking_groups = material.marking_groups, project_groups = material.project_groups, variants = material.variants, print_parameters = material.print_parameters;
    var format_version = general.format_version, name = general.name, revision = general.revision, category = general.category, legacy_names = general.legacy_names, id = general.id, color_mode = general.color_mode, material_version = general.material_version;
    var _decorations = {
        rect: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.rect), false), __read((_a = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.rect) === null || _a === void 0 ? void 0 : _a.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
        polygon: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.polygon), false), __read((_b = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.polygon) === null || _b === void 0 ? void 0 : _b.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
        line: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.line), false), __read((_c = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.line) === null || _c === void 0 ? void 0 : _c.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
        circle: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.circle), false), __read((_d = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.circle) === null || _d === void 0 ? void 0 : _d.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
        arches: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.arches), false), __read((_e = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.arches) === null || _e === void 0 ? void 0 : _e.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
        text: __spreadArray(__spreadArray([], __read(none_printable_decorations === null || none_printable_decorations === void 0 ? void 0 : none_printable_decorations.text), false), __read((_f = printable_decorations === null || printable_decorations === void 0 ? void 0 : printable_decorations.text) === null || _f === void 0 ? void 0 : _f.map(function (deco) { return (__assign(__assign({}, deco), { printable: true })); })), false),
    };
    var selPrinter = Number(_selPrinter);
    var _marking_groups = (marking_groups || []).reduce(function (acc, group, index, array) {
        if (selPrinter === NO_PRINTER_ID) {
            if (group.is_default) {
                return __spreadArray(__spreadArray([], __read(acc), false), [group], false);
            }
            else {
                if (!array.some(function (item) { return item.is_default; })) {
                    return [array[0]];
                }
            }
        }
        else if (!!group.printers.length) {
            if (group.printers.indexOf(selPrinter) > -1) {
                return __spreadArray(__spreadArray([], __read(acc), false), [group], false);
            }
        }
        return acc;
    }, []);
    var _project_groups = (project_groups || []).filter(function (n) {
        if (!!n.printers.length) {
            return n.printers.indexOf(selPrinter) > -1;
        }
        return false;
    });
    var filtered_marking_groups = __spreadArray(__spreadArray([], __read(_marking_groups), false), __read(_project_groups), false);
    var filtered_legacy_names = (legacy_names === null || legacy_names === void 0 ? void 0 : legacy_names.filter(function (n) { return n.printers ? n.printer === selPrinter : false; })) || [];
    var filtered_view_options = (_g = material_layout === null || material_layout === void 0 ? void 0 : material_layout.view_options) === null || _g === void 0 ? void 0 : _g.filter(function (n) { return n.printers ? n.printers.indexOf(selPrinter) > -1 : false; });
    var input_direction = ((_h = filtered_view_options[0]) === null || _h === void 0 ? void 0 : _h.input_direction) || 0;
    var original_input_direction = ((_j = filtered_view_options[0]) === null || _j === void 0 ? void 0 : _j.original_input_direction) || 0;
    var rotated = input_direction === 90;
    var x = rotated ? 'y' : 'x';
    var y = rotated ? 'x' : 'y';
    var left = rotated ? 'top' : 'left';
    var top = rotated ? 'left' : 'top';
    var right = rotated ? 'bottom' : 'right';
    var bottom = rotated ? 'right' : 'bottom';
    var width = rotated ? 'height' : 'width';
    var height = rotated ? 'width' : 'height';
    var shield_angle_transform = function (angle) {
        var new_angle = angle + input_direction;
        return new_angle >= 360 ? new_angle - 360 : new_angle;
    };
    var getSortedShieldsFromGroup = function (group) {
        var _a, _b;
        var shields = [];
        if ((_a = group === null || group === void 0 ? void 0 : group.matrices) === null || _a === void 0 ? void 0 : _a.length) {
            group.matrices.forEach(function (m) {
                var _a;
                if ((_a = m.shields) === null || _a === void 0 ? void 0 : _a.length) {
                    m.shields.forEach(function (s) {
                        shields.push(s);
                    });
                }
            });
        }
        if ((_b = group === null || group === void 0 ? void 0 : group.shields) === null || _b === void 0 ? void 0 : _b.length) {
            group.shields.forEach(function (s) {
                shields.push(s);
            });
        }
        return shields;
    };
    var revertY = rotated && input_direction === 90;
    var tps = {
        w: material_layout.material_size[width],
        h: material_layout.material_size[height]
    };
    var tpm = {
        l: 0,
        t: 0,
        r: 0,
        b: 0
    };
    var tpa = {
        l: tpm.l,
        t: tpm.t,
        r: tps.w - tpm.r - tpm.l,
        b: tps.h - tpm.b - tpm.t,
    };
    var all_shields = [];
    if (filtered_marking_groups === null || filtered_marking_groups === void 0 ? void 0 : filtered_marking_groups.length) {
        filtered_marking_groups.forEach(function (g) {
            var g_shields = getSortedShieldsFromGroup(g);
            all_shields = __spreadArray(__spreadArray([], __read(all_shields), false), __read(g_shields), false);
        });
    }
    var new_general = {
        id: id,
        format_version: format_version,
        name: name,
        file_name: (_k = filtered_legacy_names[0]) === null || _k === void 0 ? void 0 : _k.name,
        revision: revision,
        shields_number: 0,
        type: category.toUpperCase(),
        shield_size: {
            w: ((_l = all_shields[0]) === null || _l === void 0 ? void 0 : _l.size[width]) || 0,
            h: ((_m = all_shields[0]) === null || _m === void 0 ? void 0 : _m.size[height]) || 0
        },
        color_mode: color_mode,
        material_version: material_version,
    };
    var shields_dictionary = [];
    var total_shields_count = 0;
    var shields_area = {
        l: tpa.r,
        t: tpa.b,
        r: 0,
        b: 0,
    };
    var groups = filtered_marking_groups === null || filtered_marking_groups === void 0 ? void 0 : filtered_marking_groups.map(function (g, g_index) {
        var _a, _b, _c, _d, _e;
        if ((_a = g.text_style) === null || _a === void 0 ? void 0 : _a.vertical_alignment) {
            g.text_style.vertical_alignment = ((_b = g.text_style) === null || _b === void 0 ? void 0 : _b.vertical_alignment).toUpperCase().replace('CENTER', 'MIDDLE');
        }
        if ((_c = g.text_style) === null || _c === void 0 ? void 0 : _c.horizontal_alignment) {
            g.text_style.horizontal_alignment = ((_d = g.text_style) === null || _d === void 0 ? void 0 : _d.horizontal_alignment).toUpperCase();
        }
        var group_id = (g.group_no).toString();
        var sorted_shields = getSortedShieldsFromGroup(g);
        var matrices = (_e = g === null || g === void 0 ? void 0 : g.matrices) === null || _e === void 0 ? void 0 : _e.sort(function (a, b) { return a.id > b.id ? 1 : -1; }).map(function (m) {
            var ids = parseV2Id(m.id);
            var _mid = "g" + ids.g + "m" + ids.m;
            var first_right_size_shield = sorted_shields.find(function (a) { return a.size[width] === m.shield_size[width] && a.size[height] === m.shield_size[height]; });
            var first_shield = first_right_size_shield ? parseV2Id(first_right_size_shield.id) : parseV2Id(sorted_shields[0].id);
            var shield_definition_id = "g" + first_shield.g + "s" + first_shield.s + "T" + (first_shield.s + total_shields_count);
            return {
                id: _mid,
                shield_definition_id: shield_definition_id,
                position: m.location,
                box: {
                    l: m.position.x,
                    t: revertY ? tpa.b - (m.position.y + (m.shield_size[height] * m.number_of_lines + m.distance_between_lines * (m.number_of_lines - 1))) : m.position.y,
                    r: m.shield_size[width] * m.number_of_columns + m.distance_between_columns * (m.number_of_columns - 1),
                    b: m.shield_size[height] * m.number_of_lines + m.distance_between_lines * (m.number_of_lines - 1),
                },
                number_of_columns: m.number_of_columns,
                number_of_lines: m.number_of_lines,
                distance_between_lines: m.distance_between_lines,
                distance_between_columns: m.distance_between_columns,
                arrange_in_columns: m.arrange_in_columns,
                numerate_from_right_to_left: m.numerate_from_right_to_left,
                numerate_from_bottom_to_top: m.numerate_from_bottom_to_top
            };
        });
        var shields = sorted_shields.map(function (s) {
            var first_right_size_shield = sorted_shields.find(function (a) { return a.size[width] === s.size[width] && a.size[height] === s.size[height]; });
            var first_shield = first_right_size_shield ? parseV2Id(first_right_size_shield.id) : parseV2Id(sorted_shields[0].id);
            var ids = parseV2Id(s.id);
            var _id = "g" + ids.g + "s" + ids.s + "T" + (ids.s + total_shields_count);
            var _mid = "g" + ids.g + "m" + ids.m;
            var shield_definition_id = "g" + first_shield.g + "s" + first_shield.s + "T" + (first_shield.s + total_shields_count);
            if (!shields_dictionary.find(function (a) { return a.id === shield_definition_id; })) {
                shields_dictionary.push({
                    id: shield_definition_id,
                    solid: {
                        box: {
                            l: 0,
                            t: 0,
                            r: (first_right_size_shield === null || first_right_size_shield === void 0 ? void 0 : first_right_size_shield.size[width]) || 0,
                            b: (first_right_size_shield === null || first_right_size_shield === void 0 ? void 0 : first_right_size_shield.size[height]) || 0,
                        },
                        contour: {
                            primitive_type: "RECT",
                            rect: {
                                x: 0,
                                y: 0,
                                w: (first_right_size_shield === null || first_right_size_shield === void 0 ? void 0 : first_right_size_shield.size[width]) || 0,
                                h: (first_right_size_shield === null || first_right_size_shield === void 0 ? void 0 : first_right_size_shield.size[height]) || 0,
                                roundedCornerRadius: 0.00
                            }
                        },
                    }
                });
            }
            var position = {
                x: s.location[x],
                y: revertY ? tpa.b - (s.location[y] + s.size[height]) : s.location[y]
            };
            shields_area.l = position.x < shields_area.l ? position.x : shields_area.l;
            shields_area.t = position.y < shields_area.t ? position.y : shields_area.t;
            shields_area.r = position.x + s.size[width] > shields_area.r ? position.x + s.size[width] : shields_area.r;
            shields_area.b = position.y + s.size[height] > shields_area.b ? position.y + s.size[height] : shields_area.b;
            return matrices ?
                {
                    id: _id,
                    shield_definition_id: shield_definition_id,
                    position: position,
                    matrix_id: _mid
                }
                :
                    {
                        id: _id,
                        shield_definition_id: shield_definition_id,
                        position: position,
                    };
        });
        total_shields_count += shields.length;
        var text_style = g.text_style;
        text_style.transforms.angle = shield_angle_transform(text_style.transforms.angle);
        if (text_style === null || text_style === void 0 ? void 0 : text_style.vertical_alignment) {
            text_style.vertical_alignment = (text_style === null || text_style === void 0 ? void 0 : text_style.vertical_alignment).toUpperCase().replace('CENTER', 'MIDDLE');
        }
        if (text_style === null || text_style === void 0 ? void 0 : text_style.horizontal_alignment) {
            text_style.horizontal_alignment = (text_style === null || text_style === void 0 ? void 0 : text_style.horizontal_alignment).toUpperCase();
        }
        return {
            id: group_id,
            group_color: g.group_color,
            active_color_mode: g.active_color_mode,
            inactive_color_mode: g.inactive_color_mode,
            text_style: text_style,
            matrices: matrices,
            shields: shields
        };
    });
    var new_rects = __spreadArray(__spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.rect), false), __read(material_layout === null || material_layout === void 0 ? void 0 : material_layout.rect), false);
    var _solid = new_rects.map(function (s, s_index) {
        return {
            id: (s_index).toString(),
            box: {
                l: s.location[x],
                t: revertY ? tpa.b - (s.location[y] + s.size[height]) : s.location[y],
                r: s.size[width],
                b: s.size[height]
            },
            contour: {
                primitive_type: "RECT",
                rect: {
                    outline_style: {
                        enabled: s.thickness > 0,
                        color: "#000000",
                        line_width: s.thickness,
                        line_type: "SOLID"
                    },
                    x: s.location[x],
                    y: revertY ? tpa.b - (s.location[y] + s.size[height]) : s.location[y],
                    w: s.size[width],
                    h: s.size[height],
                    roundedCornerRadius: s.roundedCornerRadius,
                    background_style: mapBackgroundStyle(s.background_style)
                },
                printable: !!s.printable
            },
            z: 0
        };
    });
    var new_polygons = __spreadArray(__spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.polygon), false), __read(material_layout === null || material_layout === void 0 ? void 0 : material_layout.polygon), false);
    var _polygon = new_polygons.map(function (s, index) {
        var _a;
        return {
            id: s.id,
            contour: {
                primitive_type: "POLYGON",
                polygon: {
                    points: (_a = s.points) === null || _a === void 0 ? void 0 : _a.map(function (p) {
                        return [p[x], (revertY ? tpa.b - p[y] : p[y])];
                    }),
                    background_style: mapBackgroundStyle(s.background_style),
                },
                printable: !!s.printable
            }
        };
    });
    var new_lines = __spreadArray(__spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.line), false), __read(material_layout === null || material_layout === void 0 ? void 0 : material_layout.line), false);
    var _line = new_lines.map(function (s) {
        return {
            id: s.id,
            contour: {
                primitive_type: "LINE",
                line: {
                    start_point: {
                        x: s.start_point[x],
                        y: revertY ? tpa.b - s.start_point[y] : s.start_point[y],
                    },
                    end_point: {
                        x: s.end_point[x],
                        y: revertY ? tpa.b - s.end_point[y] : s.end_point[y],
                    },
                },
                printable: !!s.printable
            }
        };
    });
    var _holes = (material_layout === null || material_layout === void 0 ? void 0 : material_layout.holes) ? getPrimitivesArrayFromObject(material_layout.holes, tpa, revertY, x, y, width, height) : null;
    var new_text = __spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.text), false);
    var _text = new_text.map(function (t) {
        var _a, _b, _c, _d, _e;
        if ((_a = t.text_style) === null || _a === void 0 ? void 0 : _a.vertical_alignment) {
            t.text_style.vertical_alignment = ((_b = t.text_style) === null || _b === void 0 ? void 0 : _b.vertical_alignment).toUpperCase().replace('CENTER', 'MIDDLE');
        }
        if ((_c = t.text_style) === null || _c === void 0 ? void 0 : _c.horizontal_alignment) {
            t.text_style.horizontal_alignment = ((_d = t.text_style) === null || _d === void 0 ? void 0 : _d.horizontal_alignment).toUpperCase();
        }
        var result = {
            id: t.id,
            primitive_type: "TEXT",
            text: {
                text: t.text,
                text_style: __assign(__assign({}, t.text_style), { transforms: __assign(__assign({}, (_e = t.text_style) === null || _e === void 0 ? void 0 : _e.transforms), { angle: t.angle }) }),
                position: {
                    x: t.location[x],
                    y: revertY ? tpa.b - (t.location[y] + t.size[height]) : t.location[y]
                },
            },
            printable: !!t.printable
        };
        return result;
    });
    var new_circle = __spreadArray(__spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.circle), false), __read(material_layout === null || material_layout === void 0 ? void 0 : material_layout.circle), false);
    var _circle = new_circle === null || new_circle === void 0 ? void 0 : new_circle.map(function (c) {
        var result = {
            id: c.id,
            primitive_type: "CIRCLE",
            circle: {
                x: c[x],
                y: revertY ? tpa.b - c[y] : c[y],
                radius: c.radius,
                thickness: c.thickness,
                color: c.color,
                layer: c.layer,
            },
            printable: !!c.printable
        };
        return result;
    });
    var new_arches = __spreadArray(__spreadArray([], __read(_decorations === null || _decorations === void 0 ? void 0 : _decorations.arches), false), __read(material_layout === null || material_layout === void 0 ? void 0 : material_layout.arches), false);
    var _arches = new_arches === null || new_arches === void 0 ? void 0 : new_arches.map(function (a) {
        var result = {
            id: a.id,
            contour: {
                primitive_type: "ARC",
                line: {
                    start_point: {
                        x: a.start_point[x],
                        y: revertY ? tpa.b - a.start_point[y] : a.start_point[y],
                    },
                    point_on_the_arc: {
                        x: a.point_arc[x],
                        y: revertY ? tpa.b - a.point_arc[y] : a.point_arc[y],
                    },
                    end_point: {
                        x: a.end_point[x],
                        y: revertY ? tpa.b - a.end_point[y] : a.end_point[y],
                    },
                },
                printable: !!a.printable
            }
        };
        return result;
    });
    var new_decorations = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(_polygon), false), __read(_line), false), __read(_text), false), __read(_circle), false), __read(_arches), false);
    if (material_layout === null || material_layout === void 0 ? void 0 : material_layout.logo) {
        new_decorations === null || new_decorations === void 0 ? void 0 : new_decorations.push({
            id: "bmp-30",
            primitive_type: "PXC_LOGO",
            pxc_logo: {
                x: material_layout.logo.location[x] || 0,
                y: revertY ? tpa.b - (material_layout.logo.location[y] + material_layout.logo.size[height]) : material_layout.logo.location[y] || 0,
                w: material_layout.logo.size[width] || 0,
                h: material_layout.logo.size[height] || 0,
                invert_color: material_layout.logo.invert_color
            }
        });
    }
    ;
    new_general.shields_number = ((_p = (_o = groups[0]) === null || _o === void 0 ? void 0 : _o.shields) === null || _p === void 0 ? void 0 : _p.length) || 0;
    var pra = {
        l: tpa.l + shields_area.l,
        t: tpa.t + shields_area.t,
        r: tpa.l + shields_area.r,
        b: tpa.t + shields_area.b
    };
    var isEndlessMaterial = (new_general === null || new_general === void 0 ? void 0 : new_general.type) === MATFILE_ENDLESS_TYPE;
    var endless_params = isEndlessMaterial ? {
        height: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[height],
        length: {
            minimum: ENDLESS_PAGE_MINIMUM_LENGTH_MM,
            standard: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[width],
            maximum: 2200.00
        }
    } : null;
    var primePlateVariables = findPrinterBlock((_q = print_parameters === null || print_parameters === void 0 ? void 0 : print_parameters.plate_parameters) === null || _q === void 0 ? void 0 : _q.variables, PRINTER_CODE_CARD_PRIME);
    var magazineRibbon = print_parameters === null || print_parameters === void 0 ? void 0 : print_parameters.magazine_ribbon;
    var printerModels = (print_parameters === null || print_parameters === void 0 ? void 0 : print_parameters.plate_parameters)
        ? {
            thermomark_card: {
                material_form: mkMaterialForm(general.category),
                material_number: print_parameters.plate_parameters.material_number,
                shield_thickness: print_parameters.plate_parameters.shield_thickness,
                print_heat: primePlateVariables === null || primePlateVariables === void 0 ? void 0 : primePlateVariables.print_heat,
                print_speed: primePlateVariables === null || primePlateVariables === void 0 ? void 0 : primePlateVariables.print_speed,
                prime_magazine_number: magazineRibbon ? Number.parseInt(magazineRibbon.magazine_code) : 0,
                prime_color_cartridge_number: magazineRibbon && Array.isArray(magazineRibbon.color_codes)
                    ? magazineRibbon.color_codes.join("")
                    : ""
            }
        }
        : {};
    var pageBox = {
        l: 0,
        t: revertY ? tpa.b - (material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[height]) : 0,
        r: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[width],
        b: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[height]
    };
    var pxc_page_margin = (_r = print_parameters === null || print_parameters === void 0 ? void 0 : print_parameters.page_margin) === null || _r === void 0 ? void 0 : _r.find(function (n) { return n.printers && n.printers.includes(selPrinter); });
    var converted_print_params = convert({
        category: category,
        pageBox: pageBox,
        shieldsBox: shields_area,
        pageMargin: pxc_page_margin,
        originalInputDirection: original_input_direction,
        printerId: selPrinter,
        printerModels: printerModels,
    });
    var matFile = {
        general: new_general,
        geometry: {
            page: {
                box: {
                    l: 0,
                    t: revertY ? tpa.b - (material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[height]) : 0,
                    r: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[width],
                    b: material_layout === null || material_layout === void 0 ? void 0 : material_layout.material_size[height]
                },
                solid: _solid,
                holes: _holes,
                decorations: new_decorations,
                shield_thickness: ((_s = print_parameters === null || print_parameters === void 0 ? void 0 : print_parameters.plate_parameters) === null || _s === void 0 ? void 0 : _s.shield_thickness) || 0
            },
            view_options: {
                layout_mode: ((_t = filtered_view_options[0]) === null || _t === void 0 ? void 0 : _t.apposition_mode) === 1 ? 'HORIZONTAL' : 'VERTICAL'
            }
        },
        layouts: [{
                name: "MM-EML (Ex18)R C1",
                groups: groups,
                shields_dictionary: shields_dictionary
            }],
        variants: variants,
        print_parameters: converted_print_params,
        // print_parameters: {
        //   canvas_color: '',
        //   printing_offsets : {
        //     l : pra.l - tpa.l,
        //     t : pra.t - tpa.t,
        //     r : pra.r - tpa.r,
        //     b : pra.b - tpa.b
        //   },
        //   print_area : {
        //     l : pra.l,
        //     t : pra.t,
        //     r : pra.r,
        //     b : pra.b
        //   },
        //   page_area : {
        //     l : tpa.l,
        //     t : tpa.t,
        //     r : tpa.r,
        //     b : tpa.b
        //   },
        //   debug_label_offset : {
        //     l : 0.00,
        //     t : 0.00,
        //     r : 0.00,
        //     b : 0.00
        //   },
        //   color_output_mode : "MONO",
        //   transforms : original_input_direction == 90?
        //   [ {
        //     action : "ROTATE_CW90",
        //     offset_central_point : {
        //       x : 0.00,
        //       y : 0.00
        //     }
        //   } ] : [],
        //   debug_input_direction : original_input_direction,
        //   printer_models : printerModels
        // }
    };
    if (endless_params) {
        matFile.geometry.endless = endless_params;
    }
    return matFile;
};
function sortObjectKeysRecursively(obj) {
    var e_1, _a;
    // Handle arrays: recursively sort each element
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return sortObjectKeysRecursively(item); });
    }
    // Handle objects: sort keys and then recursively sort their values
    else if (typeof obj === 'object' && obj !== null) {
        var sortedKeys = Object.keys(obj).sort();
        var sortedObj = {}; // Use index signature for dynamic keys
        try {
            for (var sortedKeys_1 = __values(sortedKeys), sortedKeys_1_1 = sortedKeys_1.next(); !sortedKeys_1_1.done; sortedKeys_1_1 = sortedKeys_1.next()) {
                var key = sortedKeys_1_1.value;
                sortedObj[key] = sortObjectKeysRecursively(obj[key]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sortedKeys_1_1 && !sortedKeys_1_1.done && (_a = sortedKeys_1.return)) _a.call(sortedKeys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return sortedObj; // Cast back to T, assuming the structure is preserved
    }
    // Handle primitive values: return as is
    return obj;
}
export var parseMatfileToBasicVersion = function (_matFile, _selPrinter) {
    var _a, _b, _c;
    var version = (_matFile === null || _matFile === void 0 ? void 0 : _matFile.material) ? (_b = (_a = _matFile === null || _matFile === void 0 ? void 0 : _matFile.material) === null || _a === void 0 ? void 0 : _a.general) === null || _b === void 0 ? void 0 : _b.format_version : (_c = _matFile === null || _matFile === void 0 ? void 0 : _matFile.general) === null || _c === void 0 ? void 0 : _c.format_version;
    switch (version) {
        case 1: {
            var matFileV1 = parseVersion1MatfileToBasicVersion((_matFile.hasOwnProperty('material') ? _matFile.material : _matFile));
            matfileTemplate = parseMaterial(matFileV1);
            break;
        }
        case 2: {
            var matFileV2 = parseVersion2MatfileToBasicVersion(_matFile, _selPrinter);
            matfileTemplate = parseMaterial(matFileV2);
            break;
        }
        default: {
            throw "There is no handler for ".concat(version, " version");
        }
    }
};
export var resetMatfileTemplate = function (matFile) {
    originMatFile = matFile.hasOwnProperty('material') ? matFile.material : matFile;
    matfileTemplate = parseMaterial(originMatFile);
};
function mkMaterialForm(category) {
    if (category === "UCT" || category === "UC" || category === "UM") {
        return 1;
    }
    else if (category == "US") {
        return 2;
    }
    return 0;
}
function findPrinterBlock(container, printerCode) {
    if (Array.isArray(container)) {
        for (var i = 0; i < container.length; i++) {
            var element = container[i];
            if (Object.hasOwn(element, "printers")) {
                var printerCodes = element.printers;
                if (Array.isArray(printerCodes)
                    && printerCodes.find(function (value) { return value === printerCode; })) {
                    return element;
                }
            }
        }
    }
    return null;
}
